import React, { useState, useRef, useEffect } from 'react';
import { observer } from 'mobx-react';
import clsx from 'clsx';
import style from './style.module.scss';
import { _SPORTS_STATUS } from 'common/constants/sportsConstants';
import SoccerTimeLine from '../timeline';
import { FormatUtil } from 'utils/formatUtil';
import useStore from '../../../../../hooks/useStore';
import Banner from '../../../../../components/banner';
import { _SPORTS_TYPE } from '../../../../../common/constants/sportsConstants';
import { getStreamBrowser } from '../../../liveStream/util';

const SoccerSimpleView = observer(
  ({ item, isSelected, setSelectedGame, isSelectedView, isFinal = false, isAdmin = false, openCaster }) => {
    const { bannerStore } = useStore();

    useEffect(() => {
      if (!bannerStore.activeMajorViewId || bannerStore.activeMajorViewId === 'placeholder') {
        if (Number.isInteger(item.id)) {
          bannerStore.setActiveMajorView(item.id, _SPORTS_TYPE.SOCCER);
        }
      }
    }, [bannerStore, bannerStore.activeMajorViewId, item.id]);

    if (item.isHeader) {
      if (isFinal) {
        if (item.isFinished) {
          return (
            <div className={style.headline}>
              <span>{item.date}</span>
            </div>
          );
        } else {
          return null;
        }
      } else {
        return (
          <div className={style.headline}>
            <span>{item.date}</span>
          </div>
        );
      }
    } else {
      if (isFinal && item.isFinished) {
        return (
          <div className={style.headline}>
            <span>{item.date}</span>
          </div>
        );
      }
      const scoreBoardRef = useRef();
      const timeLineOpenButtonRef = useRef();
      const { home, away, leagueName, isPk } = item.getTeamData;
      const { activeScore } = item.winnerTeam;
      const { half_home, half_away, half_active, isHalfScoreActive } = item.halfScore;
      const { statusText, statusClass, date } = item.statusData;
      const { soccerTime, isActiveTime } = item.getProgressTime;
      const {
        videoLink,
        id,
        betbleUri,
        gameStatus,
        startDatetime,
        checkTimeLineButton,
        goalEvent,
        getMMDD,
        cheerCount,
      } = item;
      const [isOpenTimeLine, toggleOpenTimeLine] = useState(false);
      const [isBottom, setIsBottom] = useState(false);

      const onClickDetail = (event) => {
        event.preventDefault();
        event.stopPropagation();
        window.open(`/match/soccer/${item.id}`, `detail_${item.id}`, 'width=1000px,height=901px,scrollbars=yes');
      };

      const onClickBetble = (event) => {
        event.preventDefault();
        event.stopPropagation();

        let type = 0;

        if (_SPORTS_STATUS[gameStatus] === 1) {
          type = 1;
        }

        const url = `https://betble.com/game/game.php?type=${type}${item.betbleUri}`;

        window.open(url);
      };

      const setSelectedItem = (event) => {
        event.preventDefault();
        event.stopPropagation();
        // debugger;

        setSelectedGame(isSelected, id, startDatetime, gameStatus, 'soccer');
      };

      const onClickTimeLine = (e) => {
        e.stopPropagation();
        if (checkTimeLineButton) {
          const eventBoardPosition = e.currentTarget.offsetParent.offsetTop;
          const scoreBoardHeight = scoreBoardRef.current.clientHeight;
          const soccerBoardHeight = document.querySelector('#soccer_board').clientHeight;
          const eventBoardMaxHeight = 497;
          const bottomBannerHeight = 130;
          const minIframeHeight = soccerBoardHeight;
          const pageY = eventBoardPosition + scoreBoardHeight + 1;

          if (
            pageY + eventBoardMaxHeight > soccerBoardHeight &&
            soccerBoardHeight - bottomBannerHeight + eventBoardMaxHeight > minIframeHeight
          ) {
            setIsBottom(true);
          }

          toggleOpenTimeLine(!isOpenTimeLine);
        } else {
          return;
        }
      };

      const onClickLeague = (event) => {
        if (isAdmin) {
          event.stopPropagation();
          openCaster(1, item.id);
        }
      };
      const onClickVideo = (event) => {
        event.stopPropagation();
        getStreamBrowser(videoLink);
      };
      return (
        <>
          <a onClick={onClickDetail} className={style.score_board} ref={scoreBoardRef}>
            {/* 리그 */}
            <div
              className={clsx(style.cell, style.cell_league)}
              style={{ backgroundColor: `#${item.league.color}` }}
              onClick={onClickLeague}
            >
              <span className={style.league}>{leagueName}</span>
            </div>
            {/* 리그 end */}

            {/* status */}
            <div className={clsx(style.cell, style.cell_date, isSelectedView && style.cell_selected)}>
              {isSelectedView ? (
                <>
                  <span>{getMMDD}</span>
                  <span>{date}</span>
                </>
              ) : (
                date
              )}
            </div>
            <div className={clsx(style.cell, style.cell_state)}>
              {gameStatus === 'IN_PROGRESS' ? (
                <>
                  {isActiveTime && <strong>{`${soccerTime}'`}</strong>}
                  {statusText}
                </>
              ) : (
                <span className={clsx(style.state, style[statusClass])}>{statusText}</span>
              )}
            </div>
            {/* status end*/}

            {/* 홈팀 */}
            <div
              className={clsx(
                style.cell,
                style.cell_team,
                style.home,
                goalEvent.isActive && goalEvent.location === 'home' && style.highlight
              )}
            >
              <div className={style.team}>
                <span className={style.rank}>{home.ranking}</span>
                <span className={style.name}>{home.name}</span>
              </div>
            </div>
            {/* 홈팀 end */}

            {/* 스코어 */}
            <div
              className={clsx(style.cell, style.cell_score, checkTimeLineButton && style.timeline)}
              ref={timeLineOpenButtonRef}
              onClick={(e) => onClickTimeLine(e)}
            >
              <span className={clsx(style.home_score, activeScore === 'home' && style.on)}>{home.score}</span>
              <span className={style.center}>-</span>
              <span className={clsx(style.away_score, activeScore === 'away' && style.on)}>{away.score}</span>
              {isPk && (
                <div className={style.shoot_out}>
                  (<em className={style.on}>{home.pkScore}</em>-<em>{away.pkScore}</em>)
                </div>
              )}
            </div>
            {/* 스코어 end */}

            {/* 어웨이 */}
            <div
              className={clsx(
                style.cell,
                style.cell_team,
                style.away,
                goalEvent.isActive && goalEvent.location === 'away' && style.highlight
              )}
            >
              <div className={style.team}>
                <span className={style.name}>{away.name}</span>
                <span className={style.rank}>{away.ranking}</span>
              </div>
            </div>
            {/* 어웨이 end */}

            {/* 하프 스코어 */}
            <div className={clsx(style.cell, style.cell_half)}>
              {isHalfScoreActive && (
                <>
                  <span className={clsx(style.home_score, half_active === 'home' && style.on)}>{half_home}</span>
                  <span>-</span>
                  <span className={clsx(style.away_score, half_active === 'away' && style.on)}>{half_away}</span>
                </>
              )}
            </div>
            {/* 하프 스코어 end */}

            {/* 버튼 */}
            <div className={clsx(style.cell, style.cell_exec)}>
              {cheerCount >= 100 && <div className={style.cheer_count}>{FormatUtil.numberUnitConvert(cheerCount)}</div>}
              {!!videoLink &&
                (gameStatus === 'IN_PROGRESS' || gameStatus === 'BREAK_TIME' || gameStatus === 'PAUSE') && (
                  <button className={clsx(style.btn, style.onair)} title='생중계' onClick={onClickVideo}>
                    생중계
                  </button>
                )}

              {/*{!!betbleUri && _SPORTS_STATUS[gameStatus] !== 3 && (*/}
              {/*<button className={clsx(style.btn, style.betting)} onClick={onClickBetble}>*/}
              {/*  베팅*/}
              {/*</button>*/}
              {/*)}*/}
            </div>
            {/* 버튼 end */}

            {/* 즐겨찾기 */}
            <div className={clsx(style.cell, style.cell_favorites)}>
              <button
                className={clsx(style.btn_favorites, isSelected && isSelectedView && style.on)}
                onClick={setSelectedItem}
              >
                즐겨찾기
              </button>
            </div>
            {/* 즐겨찾기 end*/}

            {/* 타임라인 */}
            <SoccerTimeLine
              isOpen={isOpenTimeLine}
              toggleOpenTimeLine={toggleOpenTimeLine}
              timeLineOpenButtonRef={timeLineOpenButtonRef}
              item={item}
              isBottom={isBottom}
            />
            {/* 타임라인 끝*/}
          </a>
          {bannerStore.activeMajorViewId === item.id ? (
            <Banner paddingTop='10px' paddingBottom='10px' borderTop='1px solid #eceff3' />
          ) : null}
        </>
      );
    }
  }
);

export default SoccerSimpleView;
